module.exports = {
  lang: "中文",
  webwallet_mobile_app: "APP",
  webwallet_your: "你的EVM钱包",
  webwallet_wallet: "钱包",
  webwallet_home_des: "直接从区块链钱包发送或接收 EVM 代币",
  webwallet_login: "通过浏览器扩展程序登录",
  webwallet_copy_address: "复制地址",
  webwallet_qr_code: "二维码",
  webwallet_estimated_value: "估值",
  webwallet_total: "总计",
  webwallet_refresh: "刷新",
  webwallet_logout: "退出",
  webwallet_transactions: "交易记录",
  webwallet_erc20_transactions: "Erc20代币交易",
  webwallet_to_address: "接收地址",
  webwallet_to_address_pl: "请填写钱包地址",
  webwallet_cheap: "慢",
  webwallet_fast: "快",
  webwallet_simple: "简单设置",
  webwallet_advanced: "高级设置",
  webwallet_memo_pl: "最多30个字符（可选）",
  webwallet_fee: "手续费",
  webwallet_txHash: "交易单号",
  webwallet_type: "类型",
  webwallet_value: "数量",
  webwallet_status: "交易状态",
  webwallet_block_height: "区块高度",
  webwallet_tx_time: "交易时间",
  transaction_information: "交易详情",
  webwallet_refresh_balance: '刷新余额',
  available: "可用",
  delegate: "已委托",
  undelegate: "解委托",
  transfer: "转账",
  transfer_amount: "转账金额",
  memo: "备注",
  noTransaction: "暂无任何交易记录",
  noMathExtension: "请先连接麦子钱包扩展程序",
  from: "发送方",
  to: "接收方",
  transfer_account_null: "请填写收款地址",
  transfer_amount_null: "请填写转账金额",
  copy_success: "复制成功",
  copy_fail: "请手动复制",
  transfer_success: "转账成功",
  transfer_fail: "转账失败",
  transfer_amount_min: "转账金额不能低于 ",
  back_transactions: "返回交易记录",
  gas_limit: 'Gas Limit',
  gas_used: 'Gas Used',
  gas_price: 'Gas Price',
  mathExtensionLock: "请解锁您的麦子钱包",
  contract: "合约",
  TRC20_transfer: "TRC20 转账",
  check_account: '插件选择的账户和当前账户不一致',
  gas_price_min: 'Gas Price不能低于1Gwei',
  gas_limit_min: 'Gas Limit不能低于',
  prompt: '提示',
  input_data: '输入数据',
  transfer_input: '请输入十六进制数据（可选）',
  locked: '锁定',
  submit_success: '提交成功',
  gas_limit_null: 'Gas Limit不能为空',
  gas_Price_null: 'Gas Price不能为空',
  webwallet_amount_notenough: '可用余额不足',
  node_not_available:'当前节点不可用',
  webwallet_extrinsicID: '交易ID',
  webwallet_module: '模块',
  webwallet_signature: '签名',
  webwallet_address: '地址',
  webwallet_transfers: '转账记录',
  noTransfer: '暂无任何转账记录',
  Confirm:'确认',
  confirmed: '已确认',
  unconfirmed: '未确认',
  confirmations: '确认数',
  transferring: '签名中...',
  transfer_same_account: '收款人不能是自己',
  ledger_login: '通过 Ledger 登录',
  add: '添加',
  receive_tips:'该地址只能用于接收%w，请勿将其他代币发送到该地址。',
  receive: '收款',
  noAdded: '暂无可添加的代币',
  token_add_successful: '添加成功',
  token_add_fail: '添加失败',
  switch_to: '请将插件钱包切换到 %w',
  please_create_account: '请创建账号',
  webwallet_to_valid_address: '请输入有效的钱包地址',
  ledger_lock: "请解锁您的 Ledger 钱包",
  blockchain_explorer: '区块链浏览器',
  add_custom_token: '添加自定义代币',
  token_address: '合约地址',
  token_decimals: '代币精度',
  token_symbol: '代币名称',
  cancel_btn: '取消',
  invalid_address: '无效合约地址',
  token_exist: '该token已存在',
  collectibles: '收藏品',
  assets: '资产',
  add_customNFTs: '添加自定义 NFTs',
  send: '发送',
  no_information: '暂无数据',
  pending: '进行中...',
  connect_currentWallet: '请将插件切换到当前登录的钱包',
  nft_transfer_success: '发送成功。收藏品列表最多可能需要 24 小时才能同步。',
  not_nft_owner: '该 NFT 已被转移。数据同步完成后，收藏品列表将会更新',
  NFTUpdateNotice: "NFT 更新提示",
  NFTUpdateNoticeInfo: "这个界面上新发生的交易和新增的收藏品可能会导致收藏品列表延时更新（最长24小时），请您耐心等待。<br><br>如果您仍然遇到问题，请发送电子邮件至 <a class='text-blue' href='mailto:hello@mathwallet.org'>hello@mathwallet.org</a>， 我们会尽快回复您。",
}
